export default __webpack_public_path__ + "static/mob-device-tab-9f8111c8c54aee9391ae3f03576cd4b6.png";